import renderViewUtils from '../../utils/reportsRenderView/renderViewUtils'
import { IReport, triageLevelStates } from '../../store/reports/types'
import { useSelector } from 'react-redux'
import appConfigSelector from '../../store/appConfig/appConfigSelector'

interface IDataPartProps {
  archivedReports: IReport[]
  loading: any
}

const ArchivePageDataPart = ({ archivedReports, loading = false }: IDataPartProps) => {
  const viewType = useSelector(appConfigSelector.archivePageView)
  const resolveRender = ( reports: IReport[], title: string, id: string, error = false) => {
    return renderViewUtils.render(reports, viewType, title, id, error)
  }
  return (
    <>
      {resolveRender(archivedReports.filter(report => report.triage_level === triageLevelStates.ADDRESSED_AND_RESOLVED || report.triage_level === triageLevelStates.RESOLVE_AND_ARCHIVE), 'Resolved Cases', 'resolvedCases', loading)}
      {resolveRender(archivedReports.filter(report => report.triage_level === triageLevelStates.TRANSFERED_FOR_ASSIGNMENT), 'Case Transfers', 'caseTransfers', loading)}
    </>
  )
}

export default ArchivePageDataPart
